import { sentryFactory, useSentryMultiplex } from '@grantstreet/sentry'
import BaseSentry, { wrapSentryForProject } from '@grantstreet/sentry-multiplex'
import { isProd } from '@grantstreet/psc-environment'

const dsns = {
  // TODO: Rename to e-wallet-vue
  // e-wallet-ui-prod and -nonprod projects.
  prod: 'https://ded410a97a884358bf82242a9ee20565@o168195.ingest.sentry.io/1242931',
  nonprod: 'https://014231ea63c54e45bcc80889e7a75913@o168195.ingest.sentry.io/5827659',
}

export const {
  sentryException: oldSentryException,
  vueErrorHandler,
  chainClient,
} = sentryFactory({
  dsns,
  clientOptions: {
    whitelistUrls: [/e-wallet\.grantstreet\.com\/.*\.js/],
  },
})

// Also export the @grantstreet/sentry-multiplex way of doing things
const Sentry = wrapSentryForProject('e-wallet-vue', {
  dsn: () => {
    // If the environment check throws an exception, we will default to logging
    // exceptions in prod, to ensure that we don't miss anything.
    let prod = true
    try {
      prod = isProd()
    }
    catch (error) {
      // If we're being initialized before isProd() works, we must be
      // about to send an event. Add a note to mention that we weren't
      // able to check isProd() in case it's relevant to the problem.
      BaseSentry.addBreadcrumb({
        message: 'Unable to check if prod. Defaulting to using prod Sentry DSN.',
        level: 'warning',
      })
    }

    return prod ? dsns.prod : dsns.nonprod
  },
  allowUrls: [/e-wallet\.grantstreet\.com\/.*\.js/],
})
export default Sentry

// This function is just a wrapper to pass the received arguments into the old
// or new sentry exception, based on the feature flag state. This will be a
// shortlived wrapper. This will be removed when the feature flag is removed,
// and the migration is completed.
export const sentryException = (...args) => useSentryMultiplex()
  ? Sentry.captureException(...args)
  : oldSentryException(...args)
